import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { SuspendAction33643gogpgl0e as SuspendAction } from './SuspendAction.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SimpleSuspendAction$link$slambdaClass;
function SimpleSuspendAction$link$slambda() {
  if (SimpleSuspendAction$link$slambdaClass === VOID) {
    class $ {
      constructor($performFunc, $this_link) {
        this.i2f_1 = $performFunc;
        this.j2f_1 = $this_link;
      }
      *k2f(it, $completion) {
        return yield* this.i2f_1(it, this.j2f_1, $completion);
      }
      ld(p1, $completion) {
        return this.k2f(p1, $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    SimpleSuspendAction$link$slambdaClass = $;
  }
  return SimpleSuspendAction$link$slambdaClass;
}
function SimpleSuspendAction$link$slambda_0($performFunc, $this_link) {
  var i = new (SimpleSuspendAction$link$slambda())($performFunc, $this_link);
  var l = (it, $completion) => i.k2f(it, $completion);
  l.$arity = 1;
  return l;
}
function *execute(dispatcher, $completion) {
  return yield* this.a2f()(dispatcher, $completion);
}
function link(_this__u8e3s4, performFunc) {
  return SimpleSuspendAction$link$slambda_0(performFunc, _this__u8e3s4);
}
var SimpleSuspendActionClass;
function SimpleSuspendAction() {
  if (SimpleSuspendActionClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'SimpleSuspendAction', VOID, VOID, [SuspendAction()], [1]);
    SimpleSuspendActionClass = $;
  }
  return SimpleSuspendActionClass;
}
//region block: exports
export {
  link as link1g490lyf7zi1a,
  SimpleSuspendAction as SimpleSuspendAction15o5glu1onh36,
  execute as execute2yvxycsuayg6m,
};
//endregion

//# sourceMappingURL=SimpleSuspendAction.mjs.map
